import { Modal } from "antd";
import { StylesModalSelectEdit } from "./styled";
import Button from "../Button";
import { useSelector } from "react-redux";
import { user } from "@lhd/features/users/selector";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@lhd/constants";
import { get } from "lodash";

interface IProps {
  handleCancel: () => void;
  isOpen: boolean;
}

const ModalSelectEdit = ({ handleCancel, isOpen }: IProps) => {
  const auth = useSelector(user);
  const workers: any = get(auth, "workers[0]", null);

  const navigate = useNavigate();

  const navigateToEditWorker = () => {
    navigate(`${ROUTES.AUTH}/${ROUTES.WORKERS}/${workers?.id}`);
    handleCancel && handleCancel();
  };

  const navigateToEditUser = () => {
    navigate(`${ROUTES.AUTH}/${ROUTES.USERS}/${auth?.id}`);
    handleCancel && handleCancel();
  };

  return (
    <Modal
      open={isOpen}
      title="情報選択"
      onCancel={handleCancel}
      footer={false}
    >
      <StylesModalSelectEdit>
        <div className="group-button">
          <Button
            label="ログイン情報"
            key="back"
            onClick={navigateToEditUser}
          />
          <Button label="社員情報" key="back" onClick={navigateToEditWorker} />
        </div>
      </StylesModalSelectEdit>
    </Modal>
  );
};

export default ModalSelectEdit;
